import * as React from 'react'
  /* @jsx mdx */
import { mdx } from '@mdx-js/react';
/* @jsxRuntime classic */

/* @jsx mdx */

export const _frontmatter = {
  "title": "[CodeWithSwiz 19] Firebase Auth support in useAuth, pt1",
  "description": "Support for Firebase Auth is one of the most requested features for useAuth and I figured what the heck, how hard can it be?",
  "published": "2021-01-12T00:00:00.000Z",
  "categories": "CodeWithSwiz, Technical, Firebase, useAuth, Livecoding",
  "hero": "./img/screenshot-1610466159667.png"
};
const layoutProps = {
  _frontmatter
};
const MDXLayout = "wrapper";
export default function MDXContent({
  components,
  ...props
}) {
  return <MDXLayout {...layoutProps} {...props} components={components} mdxType="MDXLayout">
    <p>{`Support for Firebase Auth is one of the most requested features for `}<a parentName="p" {...{
        "href": "https://useauth.dev"
      }}>{`useAuth`}</a>{` and I figured what the heck, how hard can it be?`}</p>
    <p><em parentName="p">{`CodeWithSwiz is a weekly live show. Like a podcast with video and fun hacking. Focused on experiments. `}<a parentName="em" {...{
          "href": "https://youtube.com/swizecteller"
        }}>{`Join live Mondays`}</a></em></p>
    <lite-youtube {...{
      "videoid": "qMtaaI-xjJM",
      "videostartat": "0"
    }}></lite-youtube>
    <p>{`Friend, it can be very hard. Google docs are shit. The perfect example of For Engineers, By Engineers.`}</p>
    <p>{`You find out everything that's possible. All the little trees, every detail. Want user/pass auth? Here's the code. Email link? Do this. OAuth with xyz provider? Here.`}</p>
    <p>{`You know what they don't say?`}</p>
    <p><em parentName="p">{`How to set up fricken Firebase`}</em>{` 😡`}</p>
    <h2 {...{
      "id": "the-setup"
    }}>{`The setup`}</h2>
    <pre><code parentName="pre" {...{
        "className": "language-javascript"
      }}>{`// Initialize the FirebaseUI Widget using Firebase.
var ui = new firebaseui.auth.AuthUI(firebase.auth());
`}</code></pre>
    <p>{`Ok Google, how do I import this? Where's my API key?`}</p>
    <p>{`Is there Google magic afoot and they can guess? Ask me after initialization like the `}<a parentName="p" {...{
        "href": "https://useauth.dev/docs/netlify-identity"
      }}>{`Netlify Identity widget`}</a>{` can?`}</p>
    <p>{`Nope.`}</p>
    <p><figure parentName="p" {...{
        "className": "gatsby-resp-image-figure",
        "style": {
          "textAlign": "center",
          "fontStyle": "italic"
        }
      }}>{`
    `}<span parentName="figure" {...{
          "className": "gatsby-resp-image-wrapper",
          "style": {
            "position": "relative",
            "display": "block",
            "marginLeft": "auto",
            "marginRight": "auto",
            "maxWidth": "890px"
          }
        }}>{`
      `}<a parentName="span" {...{
            "className": "gatsby-resp-image-link",
            "href": "/static/829b626090448547041992d15ce71fd2/ade5e/Firebase-error-about-missing-configuratione695di.png",
            "style": {
              "display": "block"
            },
            "target": "_blank",
            "rel": "noopener"
          }}>{`
    `}<span parentName="a" {...{
              "className": "gatsby-resp-image-background-image",
              "style": {
                "paddingBottom": "21.076233183856502%",
                "position": "relative",
                "bottom": "0",
                "left": "0",
                "backgroundImage": "url('data:image/svg+xml,%3csvg%20xmlns=\\'http://www.w3.org/2000/svg\\'%20width=\\'400\\'%20height=\\'84\\'%20viewBox=\\'0%200%20400%2084\\'%20preserveAspectRatio=\\'none\\'%3e%3cpath%20d=\\'M46%2011v2h58v3l1%203v-6h23v3l1%203v-3c0-3%200-3%204-3%202%200%203%200%202-1l-1-1-1-1-11-1c-7%200-9%200-8%201v1h-3c0-2%200-2-1-1h-1c0-2-1-2-6-2s-6%200-6%202l-2%202-2-2-1-2-1%202v1c-2-2-9-3-9-1h-1l-1-2v2c0%202%200%202-1%201-2-2-2-2-3-1l-1%201-1-1h-5l-1-2v2l-1%202c-1%200-2-1-1-2V8l-1%202c-2%203-3%203-2%200V8l-1%202c-1%202-2%202-4%201-2-2-3-2-3%200l-1%201V9l-1-1-1%202-1%202V9l-1-1-1%202v3l-1-3c-1-3-2-3-2%201m125%205c0%202%200%202-2%201-1-2-1-2-2-1l-1%201v-2h-6l-1-1-1%202-1%202-1-2c1-2%201-2-1%200l-2%203v-4c-2%202-5%203-5%201l-1-1-2-1c-2%200-2%200-2%202%200%201%200%202-1%201v-1l-1-1c-1-1-1%200-1%201v3l-1-3c-1-3-3-3-3%200%200%202%201%203%2010%203%208%200%209%200%209%202v2l-1-1-1-2c-1%200-1%203%201%205l1%203-2-1c-1-2-1-2-1%200%201%202-2%203-2%200h-1c0%202-4%202-4%201l-1-3%202%201%202%201-1-2v-1l1-2c0-3-2-3-2%200%200%202%200%202-1%200s-1-2-2%203l-1%202-1-2v-2h-1c-1%201-1%201-1-1%200-1-1-2-9-1l-9%201h-1c1-3-1-2-2%200l-1%201c0-2%200-2-1-1s-1%201-1-1c-1-3-11-2-12%201l-1%203v-3c0-2%200-2-1-1%200%202-2%203-2%201l-1-2-1%201-1%201c-1-2-8-2-8%200-1%201-1%201-1-1l-1-2v6l-1-3c-1-2-1-2-2-1-2%202-3%203-2%201%200-2-4-2-5%200-1%201-1%201-1-1l-1-2v3l-1%202-2-1h-4c-1%202%200%202%208%202h8l-1%203c0%202%201%202%2020%202%2013%200%2019%200%2018-1h-1l-2-1c0-2-16-2-17%200h-1c0-2-3-2-4-1h-1v-2a2160%202160%200%200137%202c0%202-2%203-2%200l-1%201h-1l-2-1v1l-1%201-1-2c-1-1-1-1-1%201v3l20-1h21v-3l1-2h3l1-3v-3h61v-3c0-2%200-2-1%200%200%202-2%203-2%201h-2c-2-3-17-3-18-1l-1%201v-2l-1-1-1%203-1%201v-4l-1%201h-1c0-2-12-1-12%201l-2%202-2-2-1-2-1%202v2l-1-2c0-2-8-2-8%200%200%201-1%201-1-1-1-3-2-3-1%201M97%2033v3h45a304%20304%200%200044-2h-2c0-1-2-2-9-2-6%200-8%201-8%202l-1%201-1-1v-2l-1%202-1%201v-2h-1c-2%202-2%202-2%200%200-1-1-2-5-2-5%200-6%201-6%202%200%203-2%203-2%200h-1c0%201%200%202-1%201v-1l-1-1-1%202h-1c0-2-8-2-9-1h-1c0-2%200-2-1%200l-1%201-1-2-2%202h-1c1-1%200-2-2-2l-3%202c0%201-1%201-1-1-1-2-1-2-1%200l-1%202-1-1c1-3%200-2-2%200v-3l-2%202-2%201c0-2%200-2-1-1l-1%201c-1-3-3-2-3%200h-1l-1-2-1%202v1l-1-1-1-2v2l-2-1-2-2v2m92-2v3l-1%203%2018-1c18%200%2019%200%2017-3-1-2-5-2-4-1l-1%202c-1%201-1%200-1-1h-1c-1%202-1%202-1%200-1-2-3-2-6-1h-1l-2-1c-2%200-3%201-2%202l-1%201c-1%201-1%200-1-1l-1-2v2l-1%202-1-2-1-2v2l-1%202-1-2h-1c0%202-2%203-2%201l-1-2-1%202v1l-1-2-1-2m-80%209v2h64c57%200%2063%200%2063-2l-1-2-1%201-1%203-1-3c-1-2-1-2-1%200s-2%203-2%200l-1%201c-1%201-1%201-1-1s-2-3-2-1h-1c-2-2-6-1-5%201l-1%202-1-2-1-2v1l-1%202c-1%201-1%200-1-1%200-2%200-2-1%200l-1%203-1-3c0-3-2-3-1%200l-1%202-1-2-1%201h-1c-1-2-3-3-3%200v1l-1-2-1-2v2l-2%202c-2%200-3-1-3-2l-8-1c-8%200-9%200-9%202h-1v-1l-1-1-1%202-1%201v-2c0-1%200-2-1-1h-1l-7-1c-4%200-5%201-5%202l-2%202-2-2c0-2-2-2-2%200s0%202-1%201c0-1-1-2-3-2h-4c0-1-1-1-2%201-1%201-1%201-1-1l-1%201-1%201-1-2-2%202h-1c1-2-4-3-5-1%200%201-1%201-1-1-1-1-1-1-1%201l-1%202-1-2c1-2%201-2-1%200l-2%203%201-3v-2l-2%202-2%201v-2l-1%202h-1l-1-2-2%202c-1%201-1%201-1-1l-1-2v3l-1%201-1-2-2-1c-2%200-3%200-3%202m-79%205c0%202%202%202%203%200%201-1%201-1%201%201v2l1-2%201-1c0%203%2030%203%2030%200l-1-2-1%201h-6l-6%201c0%201-1%201-1-1h-5c-3-1-4-1-4%201h-1c0-3-11-3-11%200m100%201v2h124v-2l-1-3-1%201h-1c-2-1-2-1-2%201%200%203-4%202-5%200%200-2%200-2-1%200s-1%202-1%200-2-3-2%200h-1l-1-2-2%202h-1c0-2%200-2-1%200s-1%202-1%200l-2-2v2l-1%202-1-2h-1l-1%201-2-2v2l-1%201-1-2c-1-2-1-2-1%200s-4%203-4%200c-1-2-18-2-18%201h-1v-1l-1-1-1%202-1%201v-4l-1%202h-1c-1-2-12-2-12%200l-2%202-2-2-1-2-1%202v2l-1-1c0-2-1-2-3-2h-4c0-1-1-1-1%201h-1l-1-2-1%202v2l-1-1-1-2-1%201-1%201-1-1c1-1%200-1-2-1h-3l-1-1-1%202c1%201%200%202-1%202l-1-2c1-2%201-2-1%200l-2%203%201-3-1-2-1%202-2%202-2-2-2-1c-2-1-3%200-3%201s0%202-1%201v-1l-1-1c-1-1-1%200-1%201v3l-1-3c-1-3-3-3-3%201m-77%203c-1%204-1%204%2013%204l14-1h2c1%202%208%201%2010-1s2-2-5-1H70l-3%201-2-1h-5l-5%201h-1l-1-2m77%203l2%202c2%200%202%201%202%203v3l-1-3c-1-2-1-2-2%200h-2c0-2-4-2-5%200%200%201-1%201-1-1l-1-2v2c0%203-2%204-2%201l-1%201h-2c0-2%200-2-1%200h-2c0-2%200-2-1-1-1%202-1%202-1%200-1-2-1-2-3-1l-1%201-1-2v2l-1%202-1-2-2-2c-2%200-3%201-3%203l2%202c1%200%202%201%202%203l1%203v-6h12c11%200%2011%200%2011%202s1%203%203%203h15c7%200%207%200%208-2%200-3-2-3-2%200-1%202-1%202-1%200%200-1-1-2-4-2l-5%201h-1c0-2%202-2%2025-2%2021%200%2024%200%2024-2h-1c-2%201-2%201-2-1%200-1-1-2-8-1h-10c-1-1-1-1-2%201%200%202-2%203-2%201h-1l-1-1c0-2-11-2-11%200h-3l-1%202v-3l-1-1-1%202c0%202%200%202-1%201l-2-2h-4c-2-1-3%200-3%201-1%201-1%201-1-1v-2h119v-2c0-2%200-3-2-3s-3%201-3%202l-2%202-2-2c0-2-8-3-9%200h-1c0-2%200-2-1%200s-1%202-1%200l-2-2v2l-1%202-1-2h-1l-1%201-2-2-1%201v1l-1-1-1-2v2c0%202-2%203-2%201h-2c-1-2-18-3-18-1l-1%201v-1l-1-1-1%202-1%201v-4l-1%202h-1c0-3-12-3-12%200l-2%202-2-2c0-3-2-2-2%200s0%202-1%201l-1-2h-4c-2-1-3%200-3%201h-1l-1-2-1%202v2l-1-1-1-2-1%201-1%201-1-1c1-1%200-1-2-1h-3l-1-1-1%202-1%202-1-2c1-2%201-2-1%200l-2%203v-4c-2%202-5%203-5%202l-2-2c-2-1-3%200-3%201s0%202-1%201v-1l-1-1c-1-1-1%200-1%201v3l-1-3c-1-3-3-3-3%201m62%205l-1%203h11c11%200%2011%200%2010%203h-1l-1-2v2l-1%201-1-1-1-2v1l-1%202c-1%202%200%202%204%201%204%200%204%200%203%201v3l-1%201-1-2-1-2v3l-1%201-1-2-1%201h-1c-1-3-3-2-3%200%201%203%2032%203%2033%200l-1-3-1%201c0%203-2%202-2%200-1-1-1-1-1%201s-2%203-2%200l-1%201h-1c-1-1%200-3%201-4%202-2%203-4%201-4-1-1-1%200-1%201%200%203-2%204-2%201%200-2%200-2-1%200l-1%202v-5l-1-3v-2l-1%202h-1c0-2-2-3-2-1l-1%203c-2%201-2%201-1-1%200-2%200-2-1%200-1%201-1%201-1-1l-4-2c-1%200-2%200-1%202l-1%201-1-1-1-2v2l-1%201-1-1c0-1-1-2-3-2l-2%201v3l-1-2h-1c0%202-2%201-2-1%200-1-1-1-2%201%200%202%200%202-1%200l-1-2v2m-37%206l1%202c2-1%205%201%205%203s-2%203-2%200h-1c0%201%200%202-1%201v-1l-1-1-1%202h-1c0-2-8-2-9-1h-1c0-2%200-2-1%200l-1%201-1-2-2%202h-1c1-2-4-3-5-1%200%201-1%201-1-1-1-1-1-1-1%201s-2%203-2%201h-1c-1%202%202%202%2035%202a278%20278%200%200035-1l-2-1c0-1-2-2-8-2-7%200-9%201-9%202h-3l-1%201v-2h-1c-1%201-2%200-1-2h-2l-1-1c2-2-1-4-7-4-4%200-5%200-5%202h-2c-1-2-1-2-1%200m45%209h-4c-4%200-5%200-5%202-1%202-1%202-1%200l-1-2-1%201v3l-1-1-1-2v2l-1%201-1-1-1-2-1%202v1l-1-1c0-3-1-2-2%200v3l18-1c17%200%2018%200%2018-2%200-3-2-3-3-1l-1%203v-3l-1-2v3l-1%201-1-2-1%201c-1%201-1%201-1-1l-2-2h-4M88%2074v3h45a304%20304%200%200044-2h-2c0-1-2-2-9-2-6%200-8%201-8%202l-1%201-1-1v-2l-1%202-1%201v-2c0-2%200-2-1%200-2%202-2%202-2%200%200-3-11-3-12%201l-1%202v-2l-1-1-1%202-1-1v-2l-1%202h-1c-1-2-8-2-9-1h-1c0-2%200-2-1%200l-1%201c0-2-6-2-9-1l-1-1c-1-1-1-1-1%201l-1%202-1-2c1-2%201-2-1%200l-2%203%201-3v-2l-2%202-2%201c0-2%200-2-1-1l-1%201c-1-3-3-2-3%200h-1l-1-2-1%202v1l-1-1-1-2v2l-2-1-2-2v2m6%207v2h45a304%20304%200%200044-2h-2c0-1-2-2-10-2s-10%200-10%202l-1%201-1-1h-1c-1%201-1%201-1-1%200-3-11-3-12%200%200%202%200%202-1%201l-1-1c0%201%200%202-1%201v-1l-1-1c-1-1-1%200-1%201%200%202%200%202-1%201%200-1-1-2-3-2h-4c-2-1-2-1-2%201h-1c-1-2-1-2-1%200s0%202-1%201c0-2-6-2-9-1l-1-1c-1-1-1-1-1%201l-1%202-1-2c1-2%201-2-1%200l-2%203%201-3v-2l-2%202-2%201v-2l-1%202h-1l-1-2-2%202c-1%201-1%201-1-1l-1-2v3l-1%201-1-2-2-1c-2%200-3%200-3%202m92-3v3l-1%202h36v-3l-2-2v2l-1%201-1-1-1-2v2l-1%202-1-2h-1l-1%202-1-2-1-2v1l-1%202c-1%201-1%200-1-1%200-2%200-2-1%200%200%202-1%202-1%201%200-3-2-4-3-2h-1c0-2-2-1-2%201l-1%203v-3l-1-2v2l-1%202-1-2-1-2-1%202-2%202-2-2c0-2-2-1-2%201l-1-1-1-2\\'%20fill=\\'%23d3d3d3\\'%20fill-rule=\\'evenodd\\'/%3e%3c/svg%3e')",
                "backgroundSize": "cover",
                "display": "block"
              }
            }}></span>{`
  `}<picture parentName="a">{`
          `}<source parentName="picture" {...{
                "srcSet": ["/static/829b626090448547041992d15ce71fd2/ca0a1/Firebase-error-about-missing-configuratione695di.webp 223w", "/static/829b626090448547041992d15ce71fd2/75680/Firebase-error-about-missing-configuratione695di.webp 445w", "/static/829b626090448547041992d15ce71fd2/8d1ba/Firebase-error-about-missing-configuratione695di.webp 890w", "/static/829b626090448547041992d15ce71fd2/3838e/Firebase-error-about-missing-configuratione695di.webp 1335w", "/static/829b626090448547041992d15ce71fd2/e11e5/Firebase-error-about-missing-configuratione695di.webp 1780w", "/static/829b626090448547041992d15ce71fd2/554c2/Firebase-error-about-missing-configuratione695di.webp 2188w"],
                "sizes": "(max-width: 890px) 100vw, 890px",
                "type": "image/webp"
              }}></source>{`
          `}<source parentName="picture" {...{
                "srcSet": ["/static/829b626090448547041992d15ce71fd2/e92b6/Firebase-error-about-missing-configuratione695di.png 223w", "/static/829b626090448547041992d15ce71fd2/e66bf/Firebase-error-about-missing-configuratione695di.png 445w", "/static/829b626090448547041992d15ce71fd2/4ef49/Firebase-error-about-missing-configuratione695di.png 890w", "/static/829b626090448547041992d15ce71fd2/4e814/Firebase-error-about-missing-configuratione695di.png 1335w", "/static/829b626090448547041992d15ce71fd2/701e9/Firebase-error-about-missing-configuratione695di.png 1780w", "/static/829b626090448547041992d15ce71fd2/ade5e/Firebase-error-about-missing-configuratione695di.png 2188w"],
                "sizes": "(max-width: 890px) 100vw, 890px",
                "type": "image/png"
              }}></source>{`
          `}<img parentName="picture" {...{
                "className": "gatsby-resp-image-image",
                "src": "/static/829b626090448547041992d15ce71fd2/4ef49/Firebase-error-about-missing-configuratione695di.png",
                "alt": "Firebase error about missing configuration",
                "title": "Firebase error about missing configuration",
                "loading": "lazy",
                "style": {
                  "width": "100%",
                  "height": "100%",
                  "margin": "0",
                  "verticalAlign": "middle",
                  "position": "absolute",
                  "top": "0",
                  "left": "0"
                }
              }}></img>{`
        `}</picture>{`
  `}</a>{`
    `}</span>{`
    `}<figcaption parentName="figure" {...{
          "className": "gatsby-resp-image-figcaption"
        }}>{`Firebase error about missing configuration`}</figcaption>{`
  `}</figure></p>
    <p>{`We later found the right `}<a parentName="p" {...{
        "href": "https://firebase.google.com/docs/web/setup#using-module-bundlers"
      }}>{`docs to follow for initial setup`}</a>{`. Even explains how to correctly import for a smaller bundle size.`}</p>
    <p>{`pt2 will go swimmingly 💪`}</p>
    <h2 {...{
      "id": "creating-an-auth-provider-for-useauth"
    }}>{`Creating an auth provider for useAuth`}</h2>
    <p>{`My favorite result of `}<a parentName="p" {...{
        "href": "https://swizec.com/blog/react-context-without-context-using-xstate-codewithswiz-14-15"
      }}>{`refactoring useAuth from React.Context to XState`}</a>{` is that we can support multiple auth providers. Core logic is the same, details pluggable.`}</p>
    <p><figure parentName="p" {...{
        "className": "gatsby-resp-image-figure",
        "style": {
          "textAlign": "center",
          "fontStyle": "italic"
        }
      }}>{`
    `}<span parentName="figure" {...{
          "className": "gatsby-resp-image-wrapper",
          "style": {
            "position": "relative",
            "display": "block",
            "marginLeft": "auto",
            "marginRight": "auto",
            "maxWidth": "890px"
          }
        }}>{`
      `}<a parentName="span" {...{
            "className": "gatsby-resp-image-link",
            "href": "/static/f3faa8210cb7b3d3110176a8e83e6cde/701e9/useAuth-state-machine18cgdh.png",
            "style": {
              "display": "block"
            },
            "target": "_blank",
            "rel": "noopener"
          }}>{`
    `}<span parentName="a" {...{
              "className": "gatsby-resp-image-background-image",
              "style": {
                "paddingBottom": "34.08071748878923%",
                "position": "relative",
                "bottom": "0",
                "left": "0",
                "backgroundImage": "url('data:image/svg+xml,%3csvg%20xmlns=\\'http://www.w3.org/2000/svg\\'%20width=\\'400\\'%20height=\\'136\\'%20viewBox=\\'0%200%20400%20136\\'%20preserveAspectRatio=\\'none\\'%3e%3cpath%20d=\\'M62%2021c-4%200-6%202-5%203%200%201%201%201%202-1%201-1%203-2%2047-2a1041%201041%200%2000-44%200M9%2027l3%204%203%205c0%203%202%203%2024%203%2023%200%2023%200%2023-5%200-3%202-4%204-1%202%202%2018%202%2019-1l17-1%2017-1h-17l-17-1c-1-3-17-3-19%200h-4c0-3-2-3-25-3-20%200-21%200-22%202-1%203-4%202-3-1l-1-2-2%202m181%202l-3%201-2%201h2l3%201c2%203%2018%203%2020%201l3-2-1-1-2-2c-2-2-18-1-20%201M16%2033v4h45v-9H16v5m8-2c-6%200-7%200-7%202%201%202%2041%202%2042-1l-11-1H35l-2-1-9%201m104%200c-3%200-4%201-4%202l11%201c10%200%2011%200%2013%202l2%201c-1-3%207-4%208-2s3%200%203-2-1-2-3-2h-30m81%205c-14%200-18%200-19%202l-3%201-2%201h1l4%202c3%203%2036%203%2039%200%203-2%203-3%201-3l-1-2c1-1-2-2-2-2l-18%201M66%2038c-2%202-2%202%200%204%203%203%2038%203%2040%200%202-2%202-2%200-4-2-3-38-3-40%200m84%201l-6%201-6%201c0%202%201%202%206%202l8%201h1l2-1%203-1h1l2%201%203-1h1l7%201%206-1h1c2%203%204%202%204%200s-1-2-15-3a97%2097%200%2001-18%200m-84%209l-2%202%202%201a118%20118%200%200035%201c1%201%200-4-2-6l-16-1c-14%200-15%200-17%203m87-1c0%202-3%206-3%204h-1l-1-1h-7c-4%200-5%201-5%202s2%202%2020%202h21c2%201%203%200%203-2-1-2-2-2-8-2h-8c-6%202-9%201-10-3-1-2-1-2-1%200m37%200l-3%202-2%201h2l3%202c2%202%2032%202%2034%200s0-6-2-6c-6-2-30-1-32%201m-37%2024v4h-11l-13-1c-2-3-45-3-46%200l-2%201-2-1-1-2v22l1%2021V95c0-18%200-19%202-19l2%202%2023%201%2023-1c1-2%204-2%2013-2h11v3l1%203v-3c0-3%200-3%204-3h5l-6-1c-3%200-3%200-3-4l-1-3v3m98%200c1%201%200%201-5%201-4%200-6%200-7%202h-4a226%20226%200%20000%2039c0-7%201-9%204-5%202%202%2037%202%2040-1l3-2-3-1c-3-3-38-3-40%200l-3%201c-2%200-2-19%200-19v-2c-2%200-1-8%200-8l3%202c2%202%2021%202%2023%200l2-2v-1c-2%200-3-2-1-2l-10-2h-2M15%2094v22h64l-32-1H16V72l-1%2022m149%202v24h71l-35-1h-35V72l-1%2024m7-20c-3%200-5%202-5%203h18c17%200%2018%200%2018-2l-14-1h-17m-87%207c-2%202-2%202%200%204%202%203%2062%203%2064%200%202-2%202-2%200-4-1-2-5-2-32-2-29%200-31%200-32%202m155-1c-1%202-1%204%201%205%201%202%2029%203%2032%201%202-1%203-4%201-6h-34m-36%202l-5%201c-3-1-4-1-4%201h-1c0-1-1-2-11-1l-1%201c0%203%2022%203%2022%200h1c0%202%2012%203%2013%201h1l5%201c4%200%205%200%205-2l-7-1-9-1h-9M33%2085c-3%200-2%202%202%203l5-1h12l2%201%203-1h1c0%202%2013%202%2013%200h1c2%203%204%202%204%200s-1-2-21-2H33m160%208c0%202%201%203%2017%202l14%201h2l2-1h1c1-3%200-3-7-3-14-1-20%200-22%201h-1c0-2%200-2-3-1h-1l-1-1c-1%200-2%201-1%202m120-1l-2%202c1%202%207%202%2010%201h28c16%200%2016%200%2016-2s-40-2-40%200h-1c0-1-7-2-11-1M30%2096c-4%201%203%204%208%203h5l5-1h1l2%201%203-1h1c0%202%2013%202%2013%200h1c2%203%204%202%204%200s-1-2-21-2H30m292%203h-6c-4%200-5%200-5%202s10%203%2011%201h1l13%201h15c2%200%204-2%203-3l-7-1c-16%200-21%200-22%202%200%201-1%201-1-1%200-1-1-2-2-1m-144%204l-1%203h13c1%201%209%200%2010-1h3l3%201h20c3%201%206%200%206-2s-39-2-40%200h-1c0-2-1-2-3-1h-10m-143%203l-1%203h34c0-2-1-2-8-2l-8-1H35m166%204h-4c-3%200-4%201-5%202h-1c0-2-13-2-13%200%200%201%202%202%2017%202h20c2%201%206%200%206-2%200-1-2-2-8-2h-12m-98%2022\\'%20fill=\\'%23d3d3d3\\'%20fill-rule=\\'evenodd\\'/%3e%3c/svg%3e')",
                "backgroundSize": "cover",
                "display": "block"
              }
            }}></span>{`
  `}<picture parentName="a">{`
          `}<source parentName="picture" {...{
                "srcSet": ["/static/f3faa8210cb7b3d3110176a8e83e6cde/ca0a1/useAuth-state-machine18cgdh.webp 223w", "/static/f3faa8210cb7b3d3110176a8e83e6cde/75680/useAuth-state-machine18cgdh.webp 445w", "/static/f3faa8210cb7b3d3110176a8e83e6cde/8d1ba/useAuth-state-machine18cgdh.webp 890w", "/static/f3faa8210cb7b3d3110176a8e83e6cde/3838e/useAuth-state-machine18cgdh.webp 1335w", "/static/f3faa8210cb7b3d3110176a8e83e6cde/e11e5/useAuth-state-machine18cgdh.webp 1780w"],
                "sizes": "(max-width: 890px) 100vw, 890px",
                "type": "image/webp"
              }}></source>{`
          `}<source parentName="picture" {...{
                "srcSet": ["/static/f3faa8210cb7b3d3110176a8e83e6cde/e92b6/useAuth-state-machine18cgdh.png 223w", "/static/f3faa8210cb7b3d3110176a8e83e6cde/e66bf/useAuth-state-machine18cgdh.png 445w", "/static/f3faa8210cb7b3d3110176a8e83e6cde/4ef49/useAuth-state-machine18cgdh.png 890w", "/static/f3faa8210cb7b3d3110176a8e83e6cde/4e814/useAuth-state-machine18cgdh.png 1335w", "/static/f3faa8210cb7b3d3110176a8e83e6cde/701e9/useAuth-state-machine18cgdh.png 1780w"],
                "sizes": "(max-width: 890px) 100vw, 890px",
                "type": "image/png"
              }}></source>{`
          `}<img parentName="picture" {...{
                "className": "gatsby-resp-image-image",
                "src": "/static/f3faa8210cb7b3d3110176a8e83e6cde/4ef49/useAuth-state-machine18cgdh.png",
                "alt": "useAuth state machine",
                "title": "useAuth state machine",
                "loading": "lazy",
                "style": {
                  "width": "100%",
                  "height": "100%",
                  "margin": "0",
                  "verticalAlign": "middle",
                  "position": "absolute",
                  "top": "0",
                  "left": "0"
                }
              }}></img>{`
        `}</picture>{`
  `}</a>{`
    `}</span>{`
    `}<figcaption parentName="figure" {...{
          "className": "gatsby-resp-image-figcaption"
        }}>{`useAuth state machine`}</figcaption>{`
  `}</figure></p>
    <p>{`There's an abstraction layer and `}<a parentName="p" {...{
        "href": "https://useauth.dev/docs/auth-providers"
      }}>{`basic documentation on what to do`}</a>{`. We're putting my docs to the test 😅`}</p>
    <h3 {...{
      "id": "1-stub-your-provider"
    }}>{`1. stub your provider`}</h3>
    <p>{`You start with copypasta of the abstract implementation.`}</p>
    <pre><code parentName="pre" {...{
        "className": "language-typescript"
      }}>{`// src/providers/YourThing.ts

// Auth Wrapper for Auth0
export class Auth0 implements AuthProviderClass {
  private auth0: Auth0Client.WebAuth;
  private dispatch: (eventName: string, eventData?: any) => void;
  // Auth0 specific, used for roles
  private customPropertyNamespace?: string;
  // Initialize the client and save any custom config
  constructor(params: AuthOptions) {
    // You will almost always need access to dispatch
    this.dispatch = params.dispatch;
    // Auth0 specific, used for roles
    this.customPropertyNamespace = params.customPropertyNamespace;
    // Init your client
    this.auth0 = new Auth0Client.WebAuth({
      ...(params as Auth0Options),
    });
  }
  // Makes configuration easier by guessing default options
  static addDefaultParams(params: ProviderOptions, callbackDomain: string) {
    const vals = params as Auth0Options;
    return {
      redirectUri: \`\${callbackDomain}/auth0_callback\`,
      audience: \`https://\${vals.domain}/api/v2/\`,
      responseType: "token id_token",
      scope: "openid profile email",
      ...vals,
    };
  }
  public authorize() {
    // Open login dialog
  }
  public signup() {
    // Open signup dialog
  }
  public logout(returnTo?: string) {
    // Logs user out of the underlying service
  }
  public userId(user: Auth0UserProfile): string {
    // Return the userId from Auth0 shape of data
  }
  public userRoles(user: AuthUser): string[] | null {
    // Return user roles from Auth0 shape of data
  }
  public async handleLoginCallback(): Promise<boolean> {
    // Handle login data after redirect back from service
    // Dispatch ERROR on error
    // Dispatch AUTHENTICATED on success
    // include the user object and authResult with at least an expiresIn value
  }
  public async checkSession(): Promise<{
    user: Auth0UserProfile;
    authResult: Auth0DecodedHash;
  }> {
    // verify session is still valid
    // return fresh user info
  }
}
`}</code></pre>
    <h3 {...{
      "id": "2-fill-abstract-implementation"
    }}>{`2. fill abstract implementation`}</h3>
    <p>{`Fill in those methods to fit your auth provider. Here's what we tried for Firebase Auth. Don't know yet if it works.`}</p>
    <pre><code parentName="pre" {...{
        "className": "language-typescript"
      }}>{`// src/providers/FirebaseUI.ts

constructor(params: AuthOptions) {
    // You will almost always need access to dispatch
    this.dispatch = params.dispatch;

    // Init your client
    this.ui = new FirebaseAuthUI.AuthUI(firebase.auth());
}

public authorize() {
    // Open login dialog
    this.ui.start("#firebaseui-auth-container", {
        signInOptions: [firebase.auth.EmailAuthProvider.PROVIDER_ID]
    });
}
`}</code></pre>
    <p>{`Don't quote me on that yet :)`}</p>
    <h3 {...{
      "id": "3-use-the-provider"
    }}>{`3. use the provider`}</h3>
    <p>{`Use in your app. We created a Gatsby-based example on stream`}</p>
    <pre><code parentName="pre" {...{
        "className": "language-jsx"
      }}>{`// gatsby-browser.js
export const wrapRootElement = ({ element }) => (
  <ThemeProvider theme={theme}>
    <AuthConfig
      authProvider={FirebaseUI}
      navigate={navigate}
      params={
        {
          /* ... */
        }
      }
    />
    {element}
  </ThemeProvider>
);
`}</code></pre>
    <p>{`Render `}<inlineCode parentName="p">{`<AuthConfig>`}</inlineCode>{` and provide the new auth provider. We don't know yet which params Firebase Auth is going to use. Find out next time :)`}</p>
    <h3 {...{
      "id": "4-contribute-to-useauth-"
    }}>{`4. contribute to useAuth 🙏🏻`}</h3>
    <p>{`To contribute the FirebaseUI auth provider to the core library we needed an extra step 👉 adding it to the library.`}</p>
    <p>{`That happens in `}<inlineCode parentName="p">{`package.json`}</inlineCode>{`:`}</p>
    <pre><code parentName="pre" {...{
        "className": "language-json"
      }}>{`    "source": [
        "src/providers/auth0.ts",
        "src/providers/NetlifyIdentity.ts",
        "src/providers/FirebaseUI.ts",
        "src/index.ts"
    ],
    // ...
    "files": [
        "src",
        "dist",
        "auth0.js",
        "netlify-identity.js",
        "firebase-ui.js"
    ],
`}</code></pre>
    <p>{`The `}<inlineCode parentName="p">{`"source"`}</inlineCode>{` config tells `}<a parentName="p" {...{
        "href": "https://github.com/developit/microbundle"
      }}>{`microbundle`}</a>{` to build `}<inlineCode parentName="p">{`FirebaseUI.ts`}</inlineCode>{` as its own library. Creates a bunch of files in `}<inlineCode parentName="p">{`dist/*`}</inlineCode>{` that aren't connected with the rest.`}</p>
    <p>{`The `}<inlineCode parentName="p">{`"files"`}</inlineCode>{` config tells NPM to keep `}<inlineCode parentName="p">{`./firebase-ui.js`}</inlineCode>{` when publishing. That file is a hack.`}</p>
    <pre><code parentName="pre" {...{
        "className": "language-javascript"
      }}>{`// ./firebase-ui.js

// this is a hack to improve DX
// TODO: figure out a better way
const { FirebaseUI } = require("./dist/FirebaseUI");
module.exports = { FirebaseUI };
`}</code></pre>
    <p>{`Only way I could find to:`}</p>
    <ol>
      <li parentName="ol">{`Reduce bundle size and let you use different providers without installing all of them`}</li>
      <li parentName="ol">{`Have understandable imports like `}<inlineCode parentName="li">{`import FirebaseUI from "react-use-auth/firebase-ui"`}</inlineCode></li>
    </ol>
    <p>{`If you know a better way please hit reply.`}</p>
    <h2 {...{
      "id": "in-conclusion"
    }}>{`In conclusion`}</h2>
    <p><a parentName="p" {...{
        "href": "https://swizec.com/blog/why-understanding-beats-knowledge"
      }}>{`Understanding beats knowledge`}</a>{`. Knowing how several details of Firebase work, does not mean you can make it fit together.`}</p>
    <p>{`Keep that in mind next time you write docs for your team.`}</p>
    <p>{`Cheers,`}<br />{`
~Swizec`}</p>
    <p>{`PS: it's beyond cool that TypeScript lets you define `}<em parentName="p">{`"An auth provider must conform to this API"`}</em>{` and enforces it at the compiler level. Makes this way easier 😍`}</p>

    </MDXLayout>;
}
;
MDXContent.isMDXComponent = true;
      